<template>
  <div>
    <DormList :dorms="dorms" v-if="dorms"/>
<!--     <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
    <div slot="no-more"></div>
    <div slot="no-results"></div>
    </infinite-loading>      -->
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
  </div>
</template>

<script>
import DormList from '@/components/DormList'
import FixedPopup from '@/components/FixedPopup'
import InfiniteLoading from 'vue-infinite-loading'
import axios from 'axios'
export default {
  name: 'UniversityFaculty',
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.faculty ? this.faculty.title : '',
      meta: [
        { vmid: 'description', name: 'description', content: this.faculty ? this.faculty.description : '' },
        { vmid: 'keywords', name: 'keywords', content: this.faculty ? this.faculty.keywords : '' }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: window.location.origin + '/' + this.$route.params.slug + '-yakin-ogrenci-yurtlari/' }
      ]       
    }
  },
  components: {
    DormList,
    FixedPopup,
    InfiniteLoading
  },
  data () {
    return {
      page: 1,
      dorms: null,
      popupDorms: null,
      errors: [],
      faculty: null
    }
  },
  methods: {
    infiniteHandler ($state) {
      let self = this
      axios.get(`/site/universities/dorms/${this.$route.params.slug}?faculty=${this.$route.params.faculty}?page=${this.page}`)
        .then(response => {
          // self.pagination = response.data.data
            //if (Array.isArray(self.dorms) && Array.isArray(response.data.data.data) !== true && Object.keys(response.data.data.data).length !== 0) {
            if (Array.isArray(self.dorms) && Array.isArray(response.data.data.data) && Object.keys(response.data.data.data).length !== 0 ) {              
              Object.keys(response.data.data.data).forEach(item => {
                self.dorms.push(response.data.data.data[item])
              })
              $state.loaded()
            } else {
              $state.complete()
            }          
          // self.dorms = response.data.data.data
          self.popupDorms = response.data.popups
        })
        .catch(e => {
          self.errors.push(e)
        })      
    },    
    getDorms () {
      let self = this
      axios.get(`/site/universities/dorms/${this.$route.params.slug}?faculty=${this.$route.params.faculty}`)
        .then(response => {
          self.dorms = response.data.data.data
          self.faculty = response.data.faculty
          // console.log(self.faculty)
          self.popupDorms = response.data.popups
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  created () {
    this.getDorms()
  },
  watch: {
    $route () {
      this.getDorms()
    }
  }
}
</script>

<style scoped>

</style>
